import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';

const BarChart = props => {
  const { className, data, ...rest } = props;

  const numberWithCommas = (value) => {
    return parseFloat(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    animation: false,
    legend: {
      display: true,
      position: "bottom"
    },
    layout: {
      padding: 0
    },
    type: "bar",
    tooltips: {
      callbacks: {
        label: function(tooltipItem) {
          var label = data.datasets[tooltipItem.datasetIndex].label
          var value = numberWithCommas(tooltipItem.value)
          return label + ': ' + value;
        },
        labelColor: function(tooltipItem) {
          var labelColor = data.datasets[tooltipItem.datasetIndex].backgroundColor
          return {
              backgroundColor: labelColor
          };
        }
      }
    }, 
    scales: {
      yAxes: [{
        ticks: {
          userCallback: function(value) {
            var xLabel = numberWithCommas(value)
            return xLabel;
          }
        }
      }]
    }
  };
  
  return (
    <div
      {...rest}
    >
      <Bar
        data={data}
        options={options}
        redraw
      />
    </div>
  );
};

BarChart.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object
};

export default BarChart;
